import { html } from '@design.estate/dees-element';

export const demoFunc = () => html`
  <style>
    .usageDemo {
      display: flex;
      gap: 16px;
      align-items: center;
      max-width: 520px;
      margin: 40px auto;
      padding: 24px;
      border-radius: var(--dees-radius-xl);
      background: var(--dees-color-bg-secondary);
    }
  </style>
  <div class="usageDemo">
    <dees-harness-usage
      .usage=${{ inputTokens: 1840, outputTokens: 310, totalTokens: 2150, cacheReadTokens: 1200 }}
    ></dees-harness-usage>
    <dees-harness-usage
      compact
      .usage=${{ inputTokens: 152_000, outputTokens: 9_400, totalTokens: 161_400 }}
    ></dees-harness-usage>
  </div>
`;
